import { render, staticRenderFns } from "./SegmentWorkspace.vue?vue&type=template&id=687aec5e&scoped=true"
import script from "./SegmentWorkspace.vue?vue&type=script&lang=js"
export * from "./SegmentWorkspace.vue?vue&type=script&lang=js"
import style0 from "./SegmentWorkspace.vue?vue&type=style&index=0&id=687aec5e&prod&scoped=true&lang=css"
import style1 from "./SegmentWorkspace.vue?vue&type=style&index=1&id=687aec5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687aec5e",
  null
  
)

export default component.exports